module.exports = "mutation CancelCanceledOrder($id:ID!){cancelCanceledCart(cartData:{id:$id}){cart{id}}}"